export default "<p>hijo works! {{nuevovalor}}</p>\n<input\n                 \ntype=\"text\"\n\n\n[(ngModel)]=\"nuevovalor\"\n\n/>"